import {
  AemData,
  Environment,
  TechDataVariations,
  TechDataVehicle,
} from '@/types/types';
import { retry } from '@/utils/retry';

const getBaseUrl = (env: Environment) => {
  return env === 'TEST' || env === 'INT'
    ? 'https://dev.api.oneweb.mercedes-benz.com/vans-components-be/owv/v1'
    : 'https://api.oneweb.mercedes-benz.com/vans-components-be/owv/v1';
};

const buildPath = (
  endpoint: string,
  market: string,
  language: string,
  id: string,
) => {
  return `${endpoint}/${market.toUpperCase()}/${language.toLowerCase()}/${id}`;
};

async function httpGetJson<T>(url: string): Promise<T> {
  const response = await fetch(url);

  if (!response.ok) {
    let extra = '';
    try {
      const text = (await response.text()).trim();
      if (text) extra = ` - ${text.slice(0, 200)}`;
    } catch {
      // ignore
    }

    throw new Error(
      `Request failed: ${response.status} ${response.statusText} (${url})${extra}`,
    );
  }

  return (await response.json()) as T;
}

export async function getData<T>(
  endpoint: string,
  market: string,
  language: string,
  env: Environment,
  id: string,
): Promise<T> {
  const baseUrl = getBaseUrl(env);
  const path = buildPath(endpoint, market, language, id);
  const url = `${baseUrl}/${path}`;

  return retry(() => httpGetJson<T>(url), 2, 500);
}

export const loadVehicles = (aemData: AemData): Promise<TechDataVehicle[]> => {
  return getData<TechDataVehicle[]>(
    'vehicles',
    aemData.country,
    aemData.language,
    aemData.stage,
    aemData.modelSeries,
  );
};

export const loadVariations = (
  aemData: AemData,
): Promise<TechDataVariations> => {
  return getData<TechDataVariations>(
    'variations',
    aemData.country,
    aemData.language,
    aemData.stage,
    aemData.modelSeries,
  );
};
